var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-aside',{staticClass:"menu"},[_c('p',{staticClass:"menu-label has-text-centered"},[_vm._v("\n        "+_vm._s(_vm.__("Menu"))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"menu-wrapper"},[_c('menus',{attrs:{"menus":_vm.menus,"is-active":_vm.isActive}})],1)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a903090","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/core/structure/menu/Sidebar.vue
// module id = Q5hJ
// module chunks = 66